import Controller from './Controller'
import { trace } from 'rytm-helpers'
import { getSmController } from './../shared/scrollController'
import { initOwlCarousels, destroyOwlCarousels } from './../shared/owl-carousel'

let randomizeTimeout, mouseWheelTimeout

class NewsdirController extends Controller {
  
  /**
  * on view Swap complete - just before SHOW
  * @param {Event} e
  **/
  onViewSwapComplete(e) {
    super.onViewSwapComplete(e)
    this.randomizeObjectPositions()
    if (window.innerWidth >= 768) {
      this.carousel = initOwlCarousels()
    } 
  }
  /**
  * on view hidden - animation hidden complete
  * @param {Event} e
  **/
  onViewHidden(e) {
    super.onViewHidden(e)
    destroyOwlCarousels()
    this.unsetObjectPositions()
    this.carousel = null
  }
  addEventListeners() {
    super.addEventListeners()
    $(window).on('resize', $.proxy(this.onWindowResize, this))
    $("body").on("mousewheel", $.proxy(this.onMouseWheel, this))
  }
  removeEventListeners() {
    super.removeEventListeners()
    $(window).off('resize', $.proxy(this.onWindowResize, this))
    $("body").off("mousewheel", $.proxy(this.onMouseWheel, this))
  }
  /**
   * ###########
   * ### OWN ###
   */
  // On window resize
  onWindowResize(e) {
    if (window.innerWidth < 768) {
      if (this.carousel) {
        destroyOwlCarousels()
        this.unsetObjectPositions()
        this.carousel = null
      }
    } else {
      if (!this.carousel) {
        this.carousel = initOwlCarousels()
      }
    }
    this.randomizeObjectPositions()
  }
  onMouseWheel(e) {
    if (this.carousel) {
      if (!this.pauseMouseWheelAction) {
        this.pauseMouseWheelAction = true
        const delta = e.originalEvent.wheelDelta
        if (delta < 0) {
          this.carousel.trigger('next.owl')
        } else {
          this.carousel.trigger('prev.owl')
        }
      }
      clearTimeout(mouseWheelTimeout)
      mouseWheelTimeout = setTimeout(() => {
        this.pauseMouseWheelAction = false
      }, 20)
    }
  }

  // ### update news positions 
  randomizeObjectPositions() {
    if (this.isRandomizing) {
      return
    }
    this.isRandomizing = true
    // trace("randomize positions")
    const list = [...document.querySelectorAll(".news-list")]
    list.forEach(this.randomizeObjectPosition.bind(this))
    clearTimeout(randomizeTimeout)
    randomizeTimeout = setTimeout(() => {
      this.isRandomizing = false
    }, 800)
  }
  randomizeObjectPosition(el, index) {
    if (window.innerWidth < 768) {
      this.randomizeObjectPositionSm(el, index)
    } else {
      this.randomizeObjectPositionMd(el, index)
    }
  }
  // randomize X axis (Mobile)
  randomizeObjectPositionSm(el, index) {
    const inner = el.querySelector("a")
    if (!inner) {
      return
    }
    const outerRect = el.getBoundingClientRect()
    const rect = inner.getBoundingClientRect()
    const maxX = outerRect.width * .75 - rect.width
    const rand = Math.random() * (maxX * .3)
    const marginX = Math.abs(maxX * .8 * Math.sin(index)) + rand + outerRect.width * .1
    inner.style.marginTop = 0
    inner.style.marginLeft = marginX + "px"
    inner.style.opacity = 1
  }
  // randomize Y axis (Desktop)
  randomizeObjectPositionMd(el, index) {
    const inner = el.querySelector("a")
    if (!inner) {
      return
    }
    const outerRect = el.getBoundingClientRect()
    const rect = inner.getBoundingClientRect()
    const maxY = outerRect.height * .7 - rect.height
    const rand = Math.random() * (maxY * .3)
    const marginY = Math.abs(maxY * .7 * Math.sin(index)) + rand + outerRect.height * .1
    inner.style.marginLeft = 0
    inner.style.marginTop = marginY + "px"
    inner.style.opacity = 1
  }
  unsetObjectPositions() {
    // trace("unser positions")
    const list = [...document.querySelectorAll(".news-list")]
    list.forEach(this.unsetObjectPosition.bind(this))
  }
  unsetObjectPosition(el, index) {
    const inner = el.querySelector("a")
    if (!inner) {
      return
    }
    inner.style.marginTop = 0
    inner.style.marginLeft = 0
  }
  
  


}

export default NewsdirController;